import React, { createContext, useState, useRef } from 'react';

export const BenefitsRequestContext = createContext();

export const BenefitsRequestProvider = ({ children }) => {
  const [isPaymentRequestComplete, setIsPaymentRequestComplete] = useState(false);
  const [isBenefitRequestConfirmationComplete, setIsBenefitRequestConfirmationComplete] = useState(false);
  const [isPaymentModeComplete, setIsPaymentModeComplete] = useState(false);

  // Refs for child forms to register their "touch-all-fields" validate function
  const benefitRequestValidateFnRef = useRef(null);
  const claimRequestValidateFnRef = useRef(null);
  const paymentModeValidateFnRef = useRef(null);

  const triggerBenefitRequestValidation = () => {
    if (benefitRequestValidateFnRef.current) benefitRequestValidateFnRef.current();
  };

  const triggerClaimRequestValidation = () => {
    if (claimRequestValidateFnRef.current) claimRequestValidateFnRef.current();
  };

  const triggerPaymentModeValidation = () => {
    if (paymentModeValidateFnRef.current) paymentModeValidateFnRef.current();
  };

  return (
    <BenefitsRequestContext.Provider
      value={{
        isPaymentRequestComplete,
        setIsPaymentRequestComplete,
        isBenefitRequestConfirmationComplete,
        setIsBenefitRequestConfirmationComplete,
        isPaymentModeComplete,
        setIsPaymentModeComplete,
        benefitRequestValidateFnRef,
        claimRequestValidateFnRef,
        paymentModeValidateFnRef,
        triggerBenefitRequestValidation,
        triggerClaimRequestValidation,
        triggerPaymentModeValidation,
      }}
    >
      {children}
    </BenefitsRequestContext.Provider>
  );
};
